import React, { useState } from "react";
import "./style.css";
import { IoArrowBackOutline } from "react-icons/io5";
import ToggleSwitch from "../components/toggleSwitch";
import { useNavigate, useLocation } from "react-router";
import icon from "../assets/Icon.png";
import { url, getLastThreeDigits } from "../env";
import Loader from "../components/loader";
import { getDelawareDate } from "../env";
import { FaPlus, FaMinus } from "react-icons/fa6";

export default function TeacherAttendance() {
    const [loading, isLoading] = useState(false);
    const location = useLocation();
    const state = location.state;
    console.log(state);

    const navigate = useNavigate();

    const [attendanceData, setAttendanceData] = useState(
        location.state.students.map(student => ({
            ...student,
            paidHours: student.paidHours || 0 // Ensure hours field exists
        }))
    );

    // Handle attendance toggle
    const handleToggle = (empId) => {
        setAttendanceData(prevData =>
            prevData.map(student =>
                student.empId === empId
                    ? { ...student, status: student.status === "absent" ? "present" : "absent" }
                    : student
            )
        );
    };

    console.log(attendanceData, "students");

    // Function to increment hours for a specific student
    const incrementHr = (empId) => {
        setAttendanceData(prevData =>
            prevData.map(student =>
                student.empId === empId ? { ...student, paidHours: student.paidHours + 1 } : student
            )
        );
    };

    // Function to decrement hours for a specific student
    const decrementHr = (empId) => {
        setAttendanceData(prevData =>
            prevData.map(student =>
                student.empId === empId
                    ? { ...student, paidHours: student.paidHours > 0 ? student.paidHours - 1 : 0 }
                    : student
            )
        );
    };

    const updateAttendance = async () => {
        try {
            isLoading(true);

            const endpoint = `${url}employee-attendance/add`;

            const payload = {
                deptId: location.state.deptId,
                deptName: location.state.deptName,
                attendanceDate: getDelawareDate(),
                attendance: attendanceData, 
            };

            console.log(payload);

            const response = await fetch(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (!response.ok) {
                console.error("Error:", result);
                return alert(`Error: ${result.error || "Something went wrong."}`);
            }

            navigate(-1);
        } catch (error) {
            console.error("Fetch error:", error);
            alert("An error occurred while updating attendance. Please try again.");
        } finally {
            isLoading(false);
        }
    };

    return (
        <div className="attendance_page">
            <div className="mainAttendanceHeader">
                <div className="title">
                    <span className="date">{getDelawareDate()}</span>
                    <span className="courseName">{location.state.courseName}</span>
                </div>
                <div onClick={() => navigate(-1)} className="back_arrow">
                    <IoArrowBackOutline />
                </div>
                <div className="profile_icon">
                    <img src={icon} alt="Profile Icon" />
                </div>
                <div className="cummulation_attendance">
                    <div className="total_present">
                        <span className="quantity_1" style={{ color: "green" }}>
                            {attendanceData.filter((item) => item.status === "present").length}
                        </span>
                        <span className="unit_1">Present</span>
                    </div>
                    <div className="total_absent">
                        <span className="quantity_1" style={{ color: "red" }}>
                            {attendanceData.filter((item) => item.status === "absent").length}
                        </span>
                        <span className="unit_1">Absent</span>
                    </div>
                </div>
            </div>
            <div className="studentsList">
                <div className="attendanceTabHeading">
                    <span className="studentNameHeading">Emp Name</span>
                    <span className="studentRollHeading">Hours</span>
                    <span className="studentStatusHeading">Status</span>
                </div>
                {attendanceData.map((item) => (
                    <div className="attendanceTab" key={item.empId}>
                        <span className="studentName">{item.name}</span>
                        <span className="studentRoll">
                            <div className="counter">
                                <div className="btn_counter" onClick={() => decrementHr(item.empId)}>
                                    <FaMinus />
                                </div>
                                <div className="count">{item.paidHours}</div>
                                <div className="btn_counter" onClick={() => incrementHr(item.empId)}>
                                    <FaPlus />
                                </div>
                            </div>
                        </span>
                        <span className={`studentStatus ${item.status === "present" ? 'present' : 'absent'}`}>
                            <ToggleSwitch
                                id={`toggle-switch-${item.empId}`}
                                checked={item.status === "present"}
                                onChange={() => handleToggle(item.empId)}
                            />
                        </span>
                    </div>
                ))}
            </div>
            <button className="updateButton" onClick={updateAttendance}>
                Confirm & Submit Attendance
            </button>
            {loading && <Loader />}
        </div>
    );
}
